module.exports = __webpack_public_path__ + "static/media/doctor-female.0145d6f9.svg";